const agreement = [
    {
        path: "/assetDes",
        name: "用户网络服务协议",
        component: () => import("@views/other/assetDes.vue"),
        meta: {
            title: "用户网络服务协议",
        },
    },
    {
        path: "/agreementDes",
        name: "陆浦协议",
        component: () => import("@views/other/agreementDes.vue"),
        meta: {
            title: "用户网络服务协议",
        },
    },
    // {
    //     path: "/testNew",
    //     name: "临时测试",
    //     component: () => import("@views/publicFunds/newFundDetail"),
    //     meta: {
    //         title: "临时测试",
    //     },
    // }
]
export default agreement